import { A } from "@solidjs/router";
import { Accessor, Component, Show, onMount } from "solid-js";
import { CMS } from "./cms/cms";
import { createStore } from "solid-js/store";
import { loadCms } from "../app";

type State = {
    isContentReady: boolean;
}
type Props = {
    title: Accessor<string>;
}
export const Header: Component<Props> = (props) =>
{
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    onMount(async () => {
        const ids = [
            "nav::home","nav::salons","nav::7th-arc-salon"
        ];
        await loadCms(ids);
        setState({ isContentReady: true });
    });
    return (
        <Show when={state.isContentReady}>
            <section class="page-heading" style="clear:both;">
                <h1>
                    {props.title()}
                </h1>
                <p>
                    <a href="/"><CMS id="nav::home" text>Home</CMS></a> / <a href="/Salon/Home"><CMS id="nav::salons" text>Salons</CMS></a> / <A href="/"><CMS id="nav::7th-arc-salon" text>7th ARC Salon</CMS></A>
                </p>
            </section>
        </Show>
    );
}